import React from "react";

const items = [
  {
    n: "01",
    title: "Architectural Design",
    body: "From first sketch to full documentation — spatial thinking that turns a brief into a building.",
    bullets: ["Concept design", "Spatial planning", "Council documentation"],
    img: "https://images.unsplash.com/photo-1567016376408-0226e4d0c1ea?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
  },
  {
    n: "02",
    title: "Technical Drafting",
    body: "Detailed CAD and construction drawings produced to Australian standards with millimetre precision.",
    bullets: ["BIM & Revit", "Working drawings", "Structural coordination"],
    img: "https://images.unsplash.com/photo-1503387837-b154d5074bd2?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
  },
  {
    n: "03",
    title: "Building & Construction",
    body: "Project management and on-site delivery, handing you a finished build ready to occupy.",
    bullets: ["Project management", "Trade coordination", "Quality assurance"],
    img: "https://images.unsplash.com/photo-1527335988388-b40ee248d80c?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
  },
];

export default function Disciplines() {
  return (
    <section id="services" data-testid="section-disciplines" className="bg-bone py-24 md:py-40">
      <div className="w-full max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-12 gap-8 items-end mb-20 reveal">
          <p className="label col-span-12 md:col-span-2">01 — What we do</p>
          <h2 className="display col-span-12 md:col-span-9 text-[10vw] md:text-7xl lg:text-[5.5rem] leading-[0.95] tracking-tighter">
            Three disciplines. <span className="italic font-light text-rust">One studio.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 border-t border-ink/20">
          {items.map((it, idx) => (
            <article
              key={it.n}
              data-testid={`discipline-${it.n}`}
              className={`reveal group relative py-10 md:py-12 ${
                idx > 0 ? "md:border-l border-t md:border-t-0 border-ink/20" : ""
              } px-2 md:px-8`}
            >
              <div className="overflow-hidden mb-8 aspect-[4/3] cursor-arrow">
                <img
                  src={it.img}
                  alt={it.title}
                  className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
                />
              </div>
              <div className="flex items-baseline gap-4">
                <span className="display italic text-rust text-3xl">{it.n}</span>
                <h3 className="display text-3xl md:text-[2rem]">{it.title}</h3>
              </div>
              <p className="mt-5 text-base text-muted2 max-w-md leading-relaxed">{it.body}</p>
              <ul className="mt-6 space-y-1.5">
                {it.bullets.map((b) => (
                  <li key={b} className="text-[13px] uppercase tracking-[0.18em] text-ink/70 flex items-center gap-3">
                    <span className="w-4 h-px bg-rust" />
                    {b}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
